import useSingleTrackingEvent from "@Events/hooks/useSingleTrackingEvent";
import ClickAppBannerEventModel from "@Events/models/ClickAppBannerEventModel";
import React from "react";

export default function useDispatchAppBannerEvent(storeName: string) {
    const dispatchAppBannerEvent = useSingleTrackingEvent("click_app_banner", ClickAppBannerEventModel(storeName))
    const handleOnBlur: React.FocusEventHandler<HTMLInputElement> = (event) => {
        dispatchAppBannerEvent()
    }

    return handleOnBlur;
}